import { useRef } from "react";

import Textarea from "../../components/Textarea";

import CopyElement from "./CopyElement";

const LinksForm3 = ({ result, handleStatus }) => {
	const formElement = useRef(null);

	return (
		<form
			ref={formElement}
			method="post"
			action="/"
			onSubmit={(e) => e.preventDefault()}
			className="well"
		>
			<div className="form-group one">
				<Textarea
					name="str"
					label="Raw"
					reqd={false}
					value={`"${result.sponsorId}","${result.fname}","${result.lname}","${result.email}"`}
					update={null}
					errors={[]}
					note=""
					readonly={true}
				/>
			</div>

			<CopyElement url={result.registrationUrl} />

			<div className="msg-submit" style={{ marginTop: "30px" }}>
				<button
					type="button"
					className="btn btn-default"
					onClick={() => handleStatus({ status: 10 })}
				>
					<i className="fa fa-angle-left" /> &nbsp;Back
				</button>
			</div>
		</form>
	);
};

export default LinksForm3;
